// extracted by mini-css-extract-plugin
module.exports = {"githubIconContainer":"GhIcon_githubIconContainer__3ark1","githubIcon":"GhIcon_githubIcon__1Lghp"};